<template>
    <div class="account-container" v-loading="loading" style="margin-top: 80px;">

      <center  v-if="viewPart != 'verification'"> <img src="/3d/static/images/login_head01.png" style="margin-top: -80px;"></center>
     <center  v-if="viewPart == 'verification'"> <img src="/3d/static/images/login_head02.png" style="margin-top: -80px;"></center>
        <div class="account-info-inpus" v-show="viewPart == 'inputs'">

            <div class="title-operation">
                <div>
                    <el-text type="primary" @click="clickReturnBtn" tkey="返回">{{i18n.tkey("lang_return")}}</el-text>
                </div>

                <div class="inv-code-input-box">
                    <span class="inv-code-label" tkey="邀請碼(沒有可不填)">{{i18n.tkey("lang_inv_code")}}{{i18n.tkey("lang_inv_code_placeholder_hint")}}</span>
                    <br>
                    <input class="inv-code-input" :value="icode" @change="inputICode" autocomplete="off" type="text" placeholder="">
                </div>
            </div>

            <div class="title-part col-11-li" style="display: none;">
                <div class="title-span" style="margin-top: 0px;margin-bottom: 0px;">
                    <h2 tkey="註冊">{{i18n.tkey("lang_register")}}</h2>
                </div>
            </div>

            <div class="col-11-li" style="margin-top: 20px">
                <span class="country-selector-label" tkey="國家或地區">{{i18n.tkey("lang_country")}}</span>
                &nbsp;
                <div class="country-selector-box mselect">
                    <CountrySelector v-model="regCoutry" :size="'default'"  />
                </div>

            </div>

            <div class="col-11-li">
                <loginTextInput v-model="regEmail" classType="text-input2" :placeholder="i18n.tkey('lang_login_email')" style="margin-top: 20px;margin-bottom: 30px;background-color: #90bfa9;" />
            </div>

            <div class="col-11-li operation-btns" style="margin-top: 20px">


                <div>
                    <el-button size="large" color="#009688" type="primary"  style="width: 100%;padding: 10px;font-size: 18px;height:50px;" @click="clickSignUpBtn" tkey="免費註冊">{{i18n.tkey("lang_free_registration")}}</el-button>
                </div>
              <div class="checkbox-part">
                <el-checkbox v-model="checkFlag" />
                <span tkey="我已閱讀並同意">{{i18n.tkey("lang_read_agree")}}</span>
                <el-text type="primary" style="color: #009688;" @click="clickGoPolicyBtn" tkey="隱私&條款">{{i18n.tkey("lang_Terms_Policy")}}</el-text>
                <!--                    <span teky="隱私&條款">{{i18n.tkey("lang_Terms_Policy")}}</span>-->
              </div>
            </div>

        </div>

        <div v-show="viewPart == 'policy'">
            <div style="text-align: left; margin-bottom: 15px">
                <el-button @click="goInputsPart" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
            </div>

            <PrivacyAgreement style="background-color: #FFFFFF"/>

            <div style="text-align: center; margin-top: 15px; margin-bottom: 15px;">
                <el-button @click="goInputsPart" tkey="返回">{{i18n.tkey("lang_return")}}</el-button>
            </div>
        </div>

        <div v-if="viewPart == 'verification'">
            <div class="title-part col-11-li">
                <div class="title-span" style="text-align: left;">
                    <span class="vcode-label" tkey="請輸入驗證碼">{{i18n.tkey("lang_please_input_vcode")}}</span>
                </div>
                <div class="title-span" style="text-align: left;">
                    <span class="vcode-label" tkey="您的啟動密碼已發送至您的郵箱">{{i18n.tkey("lang_input_vcode_note")}}</span>
                </div>
            </div>

            <div class="col-11-li" style="margin-top: 30px; margin-bottom: 20px;">
                <VerificationCodeInput v-model="vcode" ref="vcodeDom" />
            </div>
          <div style="margin-top: 30px; margin-bottom: 50px;">
            <span style="color: #FFFFFF" tkey="未收到郵件？"   >{{i18n.tkey("lang_resend_code_hint_not")}}</span><span  :style="countdown == 60?'color: #42b983;':'color: #607d8b;'" @click="ResendCode()" tkey="重新發送" >{{i18n.tkey("lang_resend_code")}}</span><span v-show="countdown < 60" style="color: #ffffff;margin-left: 20px">{{countdown}}</span>
          </div>
            <div class="col-11-li" style="text-align: center">
                <el-button  color="#009688" type="primary"  style="width: 100%;padding: 10px;font-size: 18px;height:50px;"  @click="clickSubmitVCodeBtn" tkey="提交">{{i18n.tkey("lang_submit")}}</el-button>
            </div>
        </div>

        <ActivateAccount
            v-if="null != activateID && null != activateCode"
            :id="activateID"
            :code="activateCode"
            @activate-complete="activateCallback"
        />
    </div>
</template>

<script setup>
    import loginTextInput from '@/components/loginTextInput.vue'
    import {inject, ref, onBeforeMount} from "vue";
    import CountrySelector from "@/components/shopopee/country/countrySelector.vue";
    import PrivacyAgreement from "@/components/shopopee/about/privacyAgreement.vue";
    import VerificationCodeInput from "@/components/shopopee/form/verificationCodeInput.vue";
    import ActivateAccount from "@/components/shopopee/login/activateAccount.vue";
    import myUtil from "@/util/util";
    import companyApi from "@/request/companyApi";
    import userApi from "@/request/userApi";

    const emits = defineEmits(['clickReturnBtn', "signup-complete"])

    const i18n = inject("i18n")

    const vcode = ref("")
    const regEmail = ref("")
    const regCoutry = ref("HK")
    const checkFlag = ref(false)
    const icode = ref("")

    //隸屬的companycode
    const invCompanycode = ref(null)

    const viewPart = ref("inputs")
    //const viewPart = ref("verification")
    const loading = ref(false)

    const activateID = ref(null)
    const activateCode = ref(null)

    const vcodeDom = ref(null)
    const countdown = ref(60)
    let intervalId;

    function clickReturnBtn(){
        emits("clickReturnBtn")
    }

    function clickGoPolicyBtn(){
        viewPart.value = "policy"
    }

    function goInputsPart(){
        viewPart.value = "inputs"
    }

    function clickSignUpBtn(){
        var testExp = /['"\s]/

        if (myUtil.isEmpty(regCoutry.value)){
            myUtil.alertWarning(i18n.tkey("lang_select_country_pls"))
            return;
        }

        if (testExp.test(regEmail.value)){
            myUtil.alertWarning(i18n.tkey("lang_error_format_email"));
            return;
        }

        if (!myUtil.emailCheck(regEmail.value)){
            myUtil.alertWarning(i18n.tkey("lang_error_format_email"));
            return;
        }

        if (myUtil.isEmpty(regEmail.value)){
            myUtil.alertWarning(i18n.tkey("lang_please_email"))
            return
        }

        if (!checkFlag.value){
            myUtil.alertWarning(i18n.tkey("lang_is_agree"))
            return;
        }

        loading.value = true
        if (myUtil.isNotEmpty(icode.value)){
            const request = companyApi.queryCompanyInvCode
            const params = request.getParams()

            params.companycode = icode.value

            request.send(params, (res) => {
                if (res.code == 200){
                    sendVerificationCode()
                }else{
                    myUtil.alertError(i18n.tkey("lang_inv_code_not_exist"))
                    loading.value = false
                }
            }, () => {
                myUtil.alertError(i18n.tkey("lang_inv_code_not_exist"))
                loading.value = false
            })

        }else{
            sendVerificationCode()
        }

    }
    function ResendCode(){
      if (countdown.value == 60) {
        if (intervalId) { // 如果定时器已经在运行，则不执行任何操作或重置倒计时（可选）
          clearInterval(intervalId); // 清除之前的定时器（如果有的话）
          countdown.value = 60; // 重置倒计时秒数
        } else {
          // 开始倒计时
          intervalId = setInterval(() => {
            countdown.value = countdown.value - 1; // 减少秒数
            if (countdown.value <= 0) { // 如果倒计时结束
              clearInterval(intervalId); // 清除定时器
              intervalId = null; // 重置intervalId以便重新开始倒计时（可选）
              countdown.value = 60;
            }
          }, 1000); // 每1000毫秒（1秒）更新一次倒计时
        }
        sendVerificationCode()
      }
    }
    function sendVerificationCode(){
        const request = userApi.sendVCode
        const params = request.getParams()

        params.login = regEmail.value
        params.membergroup = icode.value

        request.send(params, (res) => {
            loading.value = false
            if (res.code == 200){
                vcode.value = ""
                viewPart.value = "verification"

                setTimeout(() => {
                    vcodeDom.value.focusInput()
                }, 250)
            }else{
                myUtil.alertError(res.msg)
            }
        })

    }

    function clickSubmitVCodeBtn(){
        if (myUtil.isEmpty(vcode.value) || vcode.value.length < 6){
            myUtil.alertWarning(i18n.tkey("lang_please_input_vcode"))
            return
        }

        loading.value = true

        const request = userApi.checkEmailAndVCode
        const params = request.getParams()

        params.login = regEmail.value
        params.vcode = vcode.value

        request.send(params, (res) => {
            if(res.code == 200){
                signup(res.detail)
            }else if(res.code == 201){
                loading.value = false
                myUtil.alertError(i18n.tkey("lang_repeated_email"));
            }else{
                loading.value = false
                myUtil.alertError(i18n.tkey("lang_vcode_error"));
            }
        })

    }

    function signup(vcode){
        loading.value = true

        const request = userApi.signupForCompany
        const params = request.getParams()

        params.login = regEmail.value
        params.addinfo3 = "公司名稱"
        params.telephone = "123456"
        params.password = vcode
        params.name = "陳大文"
        params.memmale = 0
        params.country = regCoutry.value
        params.membergroup = icode.value
        params.verify = vcode

        if (myUtil.isNotEmpty(invCompanycode.value)){
            params.companycode = invCompanycode.value
        }

        request.send(params, (res) => {
            if(res.code == 200){
                activateID.value = res.detail.id
                activateCode.value = res.detail.verify
            }else{
                loading.value = false
                myUtil.alertError(i18n.tkey("lang_repeated_email"));

            }
        })

    }

    function activateCallback(){
        const obj = {
            login: regEmail.value,
            password: vcode.value
        }

        emits("signup-complete", obj)
    }

    function inputICode(e){
        icode.value = e.target.value
    }

    function goActivate(login){
        regEmail.value = login
        viewPart.value = "verification"
    }

    defineExpose({
        goActivate
    })

    onBeforeMount(() => {
        if (myUtil.isNotEmpty(myUtil.getUrlValue("promotion"))){
            icode.value = myUtil.getUrlValue("promotion")
        }

        if (myUtil.isNotEmpty(myUtil.getUrlValue("cicode"))){
            invCompanycode.value = myUtil.getUrlValue("cicode")
        }
    })

</script>

<style scoped>
    ul {
        list-style: none;
        margin: 0;
        padding-left: 0;
    }

    .account-container {
        position: relative;
        width: 100%;
        box-sizing: border-box;
        padding: 15px;
        box-shadow: 5px 5px 10px #aaaaaa;
        text-align: left;
        background-color: #0e3326;
    }

    .account-info-inpus {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        justify-content: center;
    }

    .account-info-inpus .col-12-li {
        width: 100%;
    }

    .account-info-inpus .col-11-li {
        width: 90%;
    }

    .account-info-inpus .col-9-li {
        width: 75%;
    }

    .title-span {
        text-align: center;
        margin-top: 20px;
        margin-bottom: 20px;
       color: #FFFFFF;
    }

    .title-part {
        position: relative;
    }

    .title-operation {
        width: 100%;
        position: absolute;
        top: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        box-sizing: border-box;
        padding-right: 15px;
        padding-left: 15px;
        padding-top: 10px;
        z-index: 10;
    }

    .inv-code-input {
        width: 45px;
        font-size: 11px !important;
        height: 20px;
        border: 1px #888888 solid;
    }

    .inv-code-label {
        color: #fff;
        font-size: 9px;
        margin: auto;
        margin-bottom: -5px;
    }

    .inv-code-input-box {
        text-align: right;
    }

    .country-selector-box {
        display: inline-block;
        width: 100%;
    }

    .country-selector-label {
        font-size: 12px;
        font-weight: 600;
        color: #FFFFFF;
    }

    .operation-btns {
        text-align: center;
        box-sizing: border-box;
        padding-bottom: 10px;
    }

    .checkbox-part {
        text-align: center;
        font-size: 12px;
        margin-bottom: 10px;
      color: #FFFFFF;
    }

    .vcode-label {
        font-size: 18px;
        font-weight: 700;
    }




</style>